import { getVskoReqHeader } from '@utils/utils';
import { sortBy } from 'lodash-es';
import { studyProgrammeConstants } from '../../constants/apiConstants';
import { cachedApi } from '../apihelpers';

const TYPES = {
  packet: '/sam/commons/studyprogrammes/types/e1d35687-d2e0-4917-8afc-fca13886eb07',
};

async function getAllGrades() {
  return cachedApi.getAll(
    '/sam/commons/studyprogrammegroups',
    { type: studyProgrammeConstants.gradeGroup },
    getVskoReqHeader(),
  );
}

function isPacket(studyProgram) {
  return studyProgram.type.href === TYPES.packet;
}

function filterOutPackets(list) {
  return list.filter((item) => !isPacket(item));
}

async function requestProgramsAndFilterOutPackets() {
  const programs = await cachedApi.getAll(
    '/sam/commons/studyprogrammes',
    undefined,
    getVskoReqHeader(),
  );
  const filtered = filterOutPackets(programs);
  return filtered;
}

async function getAllPrograms() {
  // return requestProgramsAndFilterOutPackets();
  const allPrograms = await sortBy(await requestProgramsAndFilterOutPackets(), 'title');
  return allPrograms;
}

async function getFirstGradeStreams() {
  const firstGradeStreams = await cachedApi.getAll(
    '/sam/commons/studyprogrammegroups',
    { type: studyProgrammeConstants.firstGradeStreamGroup },
    getVskoReqHeader(),
  );
  return firstGradeStreams;
}

async function getSecondAndThirdGradeFinalities() {
  const secondAndThirdGradeFinalities = await cachedApi.getAll(
    '/sam/commons/studyprogrammegroups',
    { type: studyProgrammeConstants.secondAndThirdGradeFinalityGroup },
    getVskoReqHeader(),
  );
  return secondAndThirdGradeFinalities;
}

async function getEdActivityTypes() {
  return cachedApi.getAll('/sam/commons/educationalactivitytypes/');
}

export const loadStudyProgrammes = async () => {
  const parr = [];
  parr.push(getAllGrades());
  parr.push(getAllPrograms());
  parr.push(getFirstGradeStreams());
  parr.push(getSecondAndThirdGradeFinalities());
  parr.push(getEdActivityTypes());
  return Promise.all(parr);
};
